"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgLimitsLocation(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "5 -4 14 24" }, props),
        React.createElement("path", { d: "M7.389 9c.393.644.863 1.31 1.421 2H7v3h10v-3h-1.811a18.452 18.452 0 001.421-2H19v7H5V9zM12 0c2.211 0 4 1.845 4 4.122C16 7.214 11.934 11 12 11S8 7.214 8 4.122C8 1.844 9.789 0 12 0zm-1 2.268a2 2 0 102 3.465 2 2 0 00-2-3.465z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('LimitsLocation')(SvgLimitsLocation);
//# sourceMappingURL=LimitsLocation.js.map